import { multiSectionDigitalClockClasses } from "@mui/x-date-pickers";
import { Accordion, Container, Row, Col, Image } from 'react-bootstrap';
function DetailItem({ iconSrc, title, detail }) {
    return (
        <div className="el-flex-area mb-1">
            {iconSrc != null && ( <div className="location-icon">
                <Image src={iconSrc} alt="" className="me-3" />
            </div>)}
           
            <div className="el-content-detail">
                <p className="el-request-detail-profile-title">{title}: 
                <span className="el-request-detail-profile-name"> {detail}</span></p>
            </div>
        </div>
    );
}
export default DetailItem